const API_BASE_URL = process.env.REACT_APP_API_URL;

export const api = {
  login: async (username, password) => {
    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      
      if (!response.ok) throw new Error('Login failed');
      return response.json();
    } catch (error) {
      throw error;
    }
  },

  logout: async (username) => {
    try {
      const response = await fetch(`${API_BASE_URL}/logout`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ username }),
      });
      
      if (!response.ok) throw new Error('Logout failed');
      return response.json();
    } catch (error) {
      throw error;
    }
  },
  
  getEvents: async (from = null, signal = null) => {
    try {
      const params = from ? `?from=${encodeURIComponent(from)}` : '';
      const response = await fetch(`${API_BASE_URL}/events${params}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        signal
      });
      if (!response.ok) throw new Error('Failed to fetch events');
      const data = await response.json();

      // Server returns array directly, wrap it for App.js compatibility
      return {
        events: data,
        pagination: null
      };
    } catch (error) {
      throw error;
    }
  },

  getHeartbeat: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/heartbeat`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (!response.ok) throw new Error('Failed to fetch heartbeat');
      return response.json();
    } catch (error) {
      throw error;
    }
  },

  getStatus: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/status`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (!response.ok) throw new Error('Failed to fetch status');
      return response.json();
    } catch (error) {
      throw error;
    }
  },

  fetchDashboardStats: async () => {
    const response = await fetch(`${API_BASE_URL}/dashboardStats`, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
    if (!response.ok) throw new Error('Failed to fetch dashboard stats');
    return response.json();
  },

  fetchLoginStats: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/loginStats`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (!response.ok) throw new Error('Failed to fetch login statistics');
      return response.json();
    } catch (error) {
      throw error;
    }
  },

  acknowledgeEvent: async (eventId) => {
    try {
      const username = localStorage.getItem('username');
      console.log('I am capturing my username', username);
      console.log('The received eventID is: ', eventId);

      const response = await fetch(`${API_BASE_URL}/events/${eventId}/acknowledge`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          acknowledgedBy: username,
          acknowledgedAt: new Date().toISOString(),
          acknowledged: true
        })
      });
      
      if (!response.ok) throw new Error('Failed to acknowledge event');
      return response.json();
    } catch (error) {
      throw error;
    }
  },

  getReports: async (from = null, to = null, filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (from) params.append('from', from);
      if (to)   params.append('to', to);
      Object.entries(filters).forEach(([k, v]) => { if (v) params.append(k, v); });
      const query = params.toString() ? `?${params.toString()}` : '';
      const response = await fetch(`${API_BASE_URL}/reports${query}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      if (!response.ok) throw new Error('Failed to fetch reports');
      return response.json();
    } catch (error) {
      throw error;
    }
  },

  updateEventStatus: async (eventId, status, comment) => {
    try {
      const username = localStorage.getItem('username');
      const token = localStorage.getItem('token');
      
      console.log('Debug info:', { 
        eventId, 
        status, 
        username, 
        tokenExists: !!token,
        endpoint: `${API_BASE_URL}/events/${eventId}/status`
      });
      
      const response = await fetch(`${API_BASE_URL}/events/${eventId}/status`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ 
          status, 
          comment,
          acknowledgedBy: username,
          updatedAt: new Date().toISOString()
        })
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Response error:', response.status, errorText);
        throw new Error(`Failed to update event status: ${response.status} ${errorText}`);
      }
      
      return response.json();
    } catch (error) {
      console.error('Update error:', error);
      throw error;
    }
  },






};